import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(
  (theme) => ({
    title: {
      ...theme.eatclub.typography.cancelTitle,
      maxWidth: '700px',
      textWrap: 'pretty',
    },
    mainContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: '30px',
      lineHeight: '1.4',
    },
    pageContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: '50px',
      fontSize: '18px',
      // maxWidth: '800px',
    },
    pauseItems: {
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
    },
    pauseItem: {
      display: 'flex',
      gap: '24px',
    },
    pauseItemText: {
      fontSize: '16px',
      paddingTop: '4px',
    },
    checkMark: {
      border: '1px solid black',
      backgroundColor: theme.colors.lightYellowBackground,
      width: '40px',
      height: '35px',
      flexShrink: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '50px',
    },
  }),
  { name: 'SuccessPage' },
);

export default useStyles;
